import api from '@/api/api'
import { Notification } from 'element-ui'

const state = {
    constants: []
}

const getters = {
    getConstants: state => state.constants,
}

const mutations = {
    SET_CONSTANTS (state, dist) {
        state.constants = dist
    },
    DELETE_CONSTANT (state, constants) {
        for (let item of state.constants) {
			if (item.id == constants) {        
				let index = state.constants.indexOf(item)
				state.constants.splice(index, 1)
			}
		}
    }
}

const actions = {
    async fetchConstants ({commit}) {
        let dist = await api.fetchConstants()
        commit('SET_CONSTANTS', dist.data.data)
    },
    async saveConstant ({commit}, constant) {
        let response
        await api.saveConstant(constant)
        .then((res) => {
            response = res
        })
        .catch((err) => {
            response = err.data
        })
        if (response.status === 201) {
            Notification.success({
                title: 'Success',
                message: 'Constant has been successfully added.'
            })
            return 'success'
        } else if (response.type === 'validation_error') {
            return response.fields
        }
    },
    async updateConstant ({commit}, constant) {
        console.log(constant);
        let response
        await api.updateConstant(constant.id, constant)
        .then((res) => {
            response = res
        })
        .catch((err) => {
            response = err.data
        })
        if (response.status === 200) {
            Notification.success({
                title: 'Success',
                message: 'Content has been successfully updated.'
            })
            return 'success'
        } else if (response.type === 'validation_error') {
            return response.fields
        }
    },
    async deleteConstant ({commit}, id) {
        let response
        await api.deleteConstant(id)
        .then((res) => {
            response = res.status
        })
        .catch((err) => {
            response = err
        })

        if (response === 204) {
            commit('DELETE_CONSTANT', id)
        }
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/constants.js